<template>
  <button class="base-button"
          :class="buttonClasses"
          :type="$props.type"
          :disabled="$props.disabled || $props.loading"
          @click="handleClick">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'base-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    link: Boolean,
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => {
        const allowedVariants = ['primary', 'secondary', 'gradient', 'text', 'white']
        return allowedVariants.includes(value)
      }
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => {
        const allowedSizes = ['normal', 'small']
        return allowedSizes.includes(value)
      }
    },
    block: Boolean
  },
  computed: {
    buttonClasses () {
      return {
        [`variant-${this.$props.variant}`]: this.$props.variant,
        [`size-${this.$props.size}`]: this.$props.size,
        block: this.$props.block
      }
    }
  },
  methods: {
    handleClick (e) {
      if (this.$props.type === 'button') {
        e.preventDefault()
      }
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss" src="./base-comp-styles/base-button.scss"></style>
